import { useLocalStorage } from 'usehooks-ts';
import { useState } from 'react';
import { SEARCH_MENU_ITEMS } from '@shared/types/frontend/searchHome';
import classNames from '@/lib/misc/classNames';
import { useSession } from '@/contexts/LitSessionProvider';
import { useMixpanel } from '@/lib/misc/mixpanel';
import WildModal from '../WildModal';
import { Button } from '@/components/ui/button';
import { useSavedToken } from '@/hooks/saved/useSavedToken';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
const MenuButton = ({
  setKeyword,
  label,
  mode,
  displayName,
  setMode,
  currentMode,
  hidden,
  showWildWest,
  className
}) => {
  const isActive = mode === currentMode || label === 'Memes' && currentMode === 'recent';
  const {
    PKP
  } = useSession();
  const {
    LogToMixpanel,
    EVENTS,
    CATEGORIES
  } = useMixpanel();
  const touchHandlerName = useTouchHandlerName();
  if (hidden && !showWildWest) return null;
  const handleClick = () => {
    console.log('resetting keyword 3');
    setKeyword('');
    if (mode === 'memes') {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.search.viewMemeTokens,
        category: CATEGORIES.search
      });
    }
    if (mode === 'top') {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.search.viewTopTokens,
        category: CATEGORIES.search
      });
    }
    if (mode === 'native') {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.search.viewNativeTokens,
        category: CATEGORIES.search
      });
    }
    if (mode === 'cash') {
      LogToMixpanel({
        pkp: PKP,
        eventName: EVENTS.search.viewCashTokens,
        category: CATEGORIES.search
      });
    }
    setMode(mode);
  };
  return <div className={classNames('text-[16px] flex gap-2 py-1 px-1 min-h-[30px] font-normal rounded-full cursor-pointer text-genius-cream/50 items-center text-nowrap', {
    hidden: label === 'Wild West' && showWildWest,
    'text-genius-cream': isActive && !(label === 'Wild West' && showWildWest),
    'bg-transparent text-genius-cream/50': label === 'Degen:',
    'px-0 w-[28px] h-[26px] justify-center ta-c gap-0': label === 'arrow'
  }, className)} {...{
    [touchHandlerName]: () => {
      handleClick();
    }
  }} data-sentry-component="MenuButton" data-sentry-source-file="NormieCategories.tsx">
      <p className='flex items-center'>
        {displayName ? <>{displayName}</> : <>
            {' '}
            {label !== 'arrow' ? label == 'Wild West' ? 'Enter the Wild West' : label === 'Natives' ? 'Core' : label : ''}
          </>}
      </p>
    </div>;
};
export default function NormieCategories({
  setMode,
  mode,
  setKeyword
}) {
  const [showWildWest, setshowWildWest] = useLocalStorage('Wild West-categories', null);
  const [, setAdvancedMarketView] = useLocalStorage('advance-data', false);
  const {
    handleClearSavedTokens
  } = useSavedToken({});
  const handleWildWest = (value: boolean) => {
    setshowWildWest(value);
    setAdvancedMarketView(value);
  };
  const [showModal, setShowModal] = useState(false);
  function toggleModal() {
    setShowModal(!showModal);
  }
  const touchHandlerName = useTouchHandlerName();
  return <>
      <div className='flex flex-col justify-between gap-2 w-full items-center mb-4 mt-4'>
        <div className='w-full gap-1 justify-start flex max-w-[calc(100vw - 250px)] overflow-x-scroll no-scrollbar'>
          <div className='flex items-center justify-between w-full'>
            <div className='w-full gap-1 justify-start flex pl-2'>
              {' '}
              {SEARCH_MENU_ITEMS.map(item => {
              if (item.label === 'Wild West') return null;
              if (!item.hidden && item.label !== 'arrow') {
                return <MenuButton className='flex items-center justify-center ' key={item.modeValue} setKeyword={setKeyword} label={item.label} mode={item.modeValue} setMode={setMode} currentMode={mode} hidden={item.hidden} showWildWest={showWildWest}
                // setshowWildWest={handleWildWest}
                // setShowModal={setShowModal}
                />;
              }
              return null;
            })}
            </div>
          </div>
        </div>
      </div>

      <WildModal isModalOpen={showModal} toggleModal={toggleModal} setshowWildWest={handleWildWest} setMode={setMode} data-sentry-element="WildModal" data-sentry-source-file="NormieCategories.tsx" />
      {mode === 'saved' && <div className='w-full ta-l pl-4'>
          <Button variant='purple' className='h-[32px] text-[14px] w-[74px]' {...{
        [touchHandlerName]: () => {
          handleClearSavedTokens();
        }
      }}>
            Clear
          </Button>
        </div>}
    </>;
}